export enum LangCode {
    English = "en",
    Hindi= "hi",
    Gujurati = "gu"
  }